import axiosClient from "api/apiClient";

export const getDashboardInfo = (data: object) => {
  return axiosClient.post("/dashboard", data);
};
